import React from "react";
// import ChartJSLabel from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import { withTheme } from "styled-components";
// import G2 from '@antv/g2';
// import DataSet from '@antv/data-set'
import { equals } from "ramda";
import { VerticalMiddleContainer } from "../layout/Layout";
import { isFunction, ArrayUtil } from "../../util";
import GenerateUtil from "../../util/helper/generate";
import ColorUtil from "../../util/ColorUtil";
import { Metrics } from "../../theme";

const { makeId } = GenerateUtil;

class DonutGraph extends React.Component {
    _lastData = [];
    mutateData = {};
    chart = null;
    constructor(props){
    	super(props);
    	this.createData(props);
    }
    componentWillReceiveProps(props){
    	this.createData(props);
    }
    createData(props){
    	const { chart_id, 
    		data, 
    		labelKey, valueKey,
    		onClick,
    		theme,
    		visualColorKey,
    		hideZero,
    	} = props;
    	const labels = [];
    	const values = [];
    	const borderWidths = [];
    	const datasets = {
    		labels:[],
    	};
    	data.forEach((e,i)=>{
    		if(hideZero){
    			if(e[valueKey]>0){
    				labels.push(e[labelKey]);
    				values.push(e[valueKey]);
    				borderWidths.push(0);
    			}
    		}else{
    			labels.push(e[labelKey]);
    			values.push(e[valueKey]);
    			borderWidths.push(0);
    		}
    	});
    	this.mutateData = {
    		sum: values.length > 0 ? values.reduce((c,v)=>c+v) : 1,
    		labels,
    		datasets:[{
    			data:values,
    			borderWidth:borderWidths,
    			backgroundColor:ColorUtil.generateVisualColorOfSize(theme, visualColorKey, data.length)
    		}]
    	};
    	this._lastData = data;
    }
    onItemClick = (e, active)=>{
    	if(ArrayUtil.isAliveArray(active, true)){
    		const { data, onClick } = this.props;
    		const { _index } = active[0];
    		if(isFunction(onClick)){
    			setTimeout(()=>{
    				onClick(data[_index]);
    			}, Metrics.chart.onClickDelay);
    		}
    	}
    }
    shouldComponentUpdate(nextProps, nextState){
    	return !equals(this._lastData, nextProps.data);
    }
    render(){
    	const { visualColorKey, onClick, lowestDisplayPercent, labelFontSize, showLabel } = this.props;
    	return <VerticalMiddleContainer style={{paddingTop:10, paddingBottom:10}}>
    		<Doughnut 
    			ref={(ref)=>{this.chart=ref;}} 
    			data={this.mutateData} 
    			options={{
    				responsive:true,
    				animation:{
    					duration:Metrics.chart.duration
    				},
    				maintainAspectRatio:false,
    				onClick:this.onItemClick,
    				legend:{
    					display:false
    				},
    				plugins: {
    					datalabels: {
    						color: "white",
    						display: (context)=>{
    							var dataset = context.dataset;
    							var value = dataset.data[context.dataIndex];
    							return showLabel && ((value*100) / this.mutateData.sum) >= lowestDisplayPercent;
    						},
    						font: {
    							weight: Metrics.boldFontWeight,
    							size: labelFontSize,
    							family: "Prompt"
    						},
    						formatter: (value, context)=>{
    							return Math.round(value*100 / this.mutateData.sum) + "%";
    						}
    					}
    				}
    			}}/>
    	</VerticalMiddleContainer>;
    }
}

DonutGraph.defaultProps = {
	data: [],
	labelKey: "item",
	valueKey: "percent",
	hideZero: true,
	showLabel: true,
	labelFontSize: Metrics.fontSize.bold,
	lowestDisplayPercent: 10
};
export default withTheme(DonutGraph);


// WEBPACK FOOTER //
// ./src/components/chart/DonutChart.js